import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MapIcon(props: IconProps) {
    return <Icon {...props} iconKey={"map"}/>
}
